import { render, staticRenderFns } from "./PagePayoutsMain.vue?vue&type=template&id=b58e8c3e&"
import script from "./PagePayoutsMain.vue?vue&type=script&lang=js&"
export * from "./PagePayoutsMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports